import { createContext, useContext } from 'react';
import type { SheetSide } from '@/shared/ui/sheet/types';

/**
 * The edge the enclosing `Sheet` is anchored to.
 *
 * Exists so `SheetContent` does not have to repeat the edge the consumer
 * already declared on the root. Defaulting here rather than requiring it
 * twice keeps a mismatched `side` impossible to express.
 */
export const SheetSideContext = createContext<SheetSide>('right');

/** Reads the anchored edge from the nearest `Sheet` root. */
export function useSheetSide(): SheetSide {
  return useContext(SheetSideContext);
}